// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3IGYK","footer":"ModalError_footer__1eB7T"};